import { AxiosError } from 'axios'
import { useQuery, UseQueryOptions } from 'react-query'

import { components } from '@plandi/common/src/generated'
import { commonApi } from './common.api'

import {
  ADVERTISEMENT_DATA,
  MY_PROFILE_COMPANY_KEY,
  MY_PROFILE_FACTORY_KEY,
  MY_PROFILE_FREELANCER_KEY
} from './common.keys'
import { PROFILE_REVIEWS_KEY } from './reviews-modal/profiles.constants'
import { useLocale } from '@plandi/common'

export const useQueryAdvertisement = (
  options?: UseQueryOptions<
    unknown,
    AxiosError,
    components['schemas']['AdvertisingResource']
  >
) => {
  const locale = useLocale()
  const query = useQuery(
    [ADVERTISEMENT_DATA, locale],
    () => commonApi.getAdvertisementData(locale),
    options
  )

  return query
}

export const useQueryMyProfileCompany = <
  T = components['schemas']['ProfileCompanyMeResource'] | undefined
>(
  options?: UseQueryOptions<
    components['schemas']['ProfileCompanyMeResource'] | undefined,
    AxiosError,
    T
  >
) => {
  const locale = useLocale()
  const data = useQuery(
    [MY_PROFILE_COMPANY_KEY, locale],
    () => commonApi.getMyProfileCompany(locale),
    options
  )

  return data
}

export const useQueryMyProfileFactory = <
  T = components['schemas']['ProfileFactoryMeResource'] | undefined
>(
  options?: UseQueryOptions<
    components['schemas']['ProfileFactoryMeResource'] | undefined,
    AxiosError,
    T
  >
) => {
  const locale = useLocale()
  const data = useQuery(
    [MY_PROFILE_FACTORY_KEY, locale],
    () => commonApi.getMyProfileFactory(locale),
    options
  )

  return data
}

export const useQueryMyProfileFreelancer = <
  T = components['schemas']['ProfileSpecialistMeResource'] | undefined
>(
  options?: UseQueryOptions<
    components['schemas']['ProfileSpecialistMeResource'] | undefined,
    AxiosError,
    T
  >
) => {
  const locale = useLocale()
  const data = useQuery(
    [MY_PROFILE_FREELANCER_KEY, locale],
    () => commonApi.getMyProfileFreelancer(locale),
    options
  )

  return data
}

export const useQueryProfileReviews = <
  T = components['schemas']['ReviewListResourse']
>(
  profileId: number,
  options?: UseQueryOptions<
    components['schemas']['ReviewListResourse'],
    AxiosError,
    T
  >
) => {
  const locale = useLocale()
  const query = useQuery(
    [PROFILE_REVIEWS_KEY, profileId, locale],
    () => commonApi.getProfileReviews(profileId, locale),
    options
  )

  return query
}
